
import Header from "../components/Header.js";
import Section from "../components/Section.js";


const Dashboard = ({setIsAuthenticated}) => {

    return (
        <>
        
        <Header setIsAuthenticated={setIsAuthenticated}/>

        <Section/>

        </>

    )
}

export default Dashboard;